export default __webpack_public_path__ + "static/media/0074.85c9f2e9.png";